(function () {
  'use strict';

  var STORAGE_KEY = 'kuuraii_attribution_v1';
  var SYNC_KEY = 'kuuraii_cart_attribution_hash_v1';
  var HANDOFF_KEY = 'kuuraii_checkout_handoff_v1';
  var VERSION = '1.5';
  var GA_MEASUREMENT_ID = 'G-VE9MM3H3MN';
  var CART_REQUEST_TIMEOUT_MS = 1800;
  var CHECKOUT_PREPARE_TIMEOUT_MS = 2600;
  var TOUCH_KEYS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_id',
    'utm_content',
    'utm_term',
    'fbclid',
    'gclid',
    'gbraid',
    'wbraid',
    'ttclid',
    'campaign_id',
    'adset_id',
    'ad_id',
    'placement',
    'site_source_name'
  ];
  var CHECKOUT_SELECTOR = [
    'button[name="checkout"]',
    'input[name="checkout"]',
    'a[href="/checkout"]',
    'a[href$="/checkout"]'
  ].join(',');
  var replayingElement = null;
  var checkoutInProgress = false;

  function now() {
    return Date.now();
  }

  function safeGet(storage, key) {
    try {
      return storage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function safeSet(storage, key, value) {
    try {
      storage.setItem(key, value);
    } catch (error) {
      // Storage may be unavailable in private or restricted browser contexts.
    }
  }

  function parseJson(value, fallback) {
    if (!value) return fallback;
    try {
      return JSON.parse(value);
    } catch (error) {
      return fallback;
    }
  }

  function clean(value, maxLength) {
    if (value === undefined || value === null) return '';
    return String(value).trim().slice(0, maxLength || 255);
  }

  function fetchWithTimeout(url, options) {
    var controller = typeof window.AbortController === 'function' ? new window.AbortController() : null;
    var requestOptions = Object.assign({}, options || {});
    if (controller) requestOptions.signal = controller.signal;

    return new Promise(function (resolve, reject) {
      var settled = false;
      var timeout = window.setTimeout(function () {
        if (settled) return;
        settled = true;
        if (controller) controller.abort();
        reject(new Error('Cart request timed out'));
      }, CART_REQUEST_TIMEOUT_MS);

      window.fetch(url, requestOptions).then(function (response) {
        if (settled) return;
        settled = true;
        window.clearTimeout(timeout);
        resolve(response);
      }).catch(function (error) {
        if (settled) return;
        settled = true;
        window.clearTimeout(timeout);
        reject(error);
      });
    });
  }

  function markStatus(value) {
    document.documentElement.setAttribute('data-kuuraii-checkout-status', value);
  }

  function newId(prefix) {
    var bytes = new Uint8Array(12);
    if (window.crypto && window.crypto.getRandomValues) {
      window.crypto.getRandomValues(bytes);
    } else {
      for (var i = 0; i < bytes.length; i += 1) bytes[i] = Math.floor(Math.random() * 256);
    }
    return prefix + '_' + Array.prototype.map.call(bytes, function (byte) {
      return byte.toString(16).padStart(2, '0');
    }).join('');
  }

  function hash(value) {
    var result = 2166136261;
    for (var i = 0; i < value.length; i += 1) {
      result ^= value.charCodeAt(i);
      result = Math.imul(result, 16777619);
    }
    return (result >>> 0).toString(36);
  }

  function cookie(name) {
    var prefix = name + '=';
    var parts = document.cookie ? document.cookie.split(';') : [];
    for (var i = 0; i < parts.length; i += 1) {
      var part = parts[i].trim();
      if (part.indexOf(prefix) === 0) return safeDecode(part.slice(prefix.length));
    }
    return '';
  }

  function allCookies() {
    var result = {};
    var parts = document.cookie ? document.cookie.split(';') : [];
    parts.forEach(function (part) {
      var separator = part.indexOf('=');
      if (separator < 0) return;
      result[part.slice(0, separator).trim()] = safeDecode(part.slice(separator + 1));
    });
    return result;
  }

  function safeDecode(value) {
    try {
      return decodeURIComponent(value);
    } catch (error) {
      return value;
    }
  }

  function gaClientId() {
    var value = cookie('_ga');
    var match = value.match(/^GA\d+\.\d+\.(\d+\.\d+)$/);
    return match ? match[1] : '';
  }

  function gaSessionId() {
    var cookies = allCookies();
    var names = Object.keys(cookies).filter(function (name) {
      return name.indexOf('_ga_') === 0;
    });
    for (var i = 0; i < names.length; i += 1) {
      var match = cookies[names[i]].match(/^GS\d+\.\d+\.s?(\d+)/);
      if (match) return match[1];
    }
    return '';
  }

  function externalReferrer() {
    if (!document.referrer) return '';
    try {
      var referrerUrl = new URL(document.referrer);
      return referrerUrl.hostname !== window.location.hostname ? referrerUrl.href : '';
    } catch (error) {
      return '';
    }
  }

  function referrerSource(referrer) {
    if (!referrer) return '';
    try {
      return new URL(referrer).hostname.replace(/^www\./, '');
    } catch (error) {
      return '';
    }
  }

  function readTouch() {
    var params = new URLSearchParams(window.location.search);
    var touch = {};
    var hasCampaignSignal = false;

    TOUCH_KEYS.forEach(function (key) {
      var value = clean(params.get(key), 255);
      if (value) {
        touch[key] = value;
        hasCampaignSignal = true;
      }
    });

    if (!touch.utm_source && (touch.gclid || touch.gbraid || touch.wbraid)) {
      touch.utm_source = 'google';
      touch.utm_medium = touch.utm_medium || 'cpc';
    }
    if (!touch.utm_source && touch.fbclid) {
      touch.utm_source = 'facebook';
      touch.utm_medium = touch.utm_medium || 'paid_social';
    }
    if (!touch.utm_source && touch.ttclid) {
      touch.utm_source = 'tiktok';
      touch.utm_medium = touch.utm_medium || 'paid_social';
    }

    var referrer = externalReferrer();
    if (!touch.utm_source && referrer) {
      touch.utm_source = referrerSource(referrer);
      touch.utm_medium = 'referral';
      hasCampaignSignal = true;
    }

    touch.landing_page = clean(window.location.href, 500);
    touch.referrer = clean(referrer || document.referrer, 500);
    touch.captured_at = new Date().toISOString();
    touch.has_campaign_signal = hasCampaignSignal;
    return touch;
  }

  function loadState() {
    var state = parseJson(safeGet(window.localStorage, STORAGE_KEY), {});
    var timestamp = now();
    var sessionStartedAt = Number(safeGet(window.sessionStorage, STORAGE_KEY + '_started_at')) || timestamp;
    var sessionId = safeGet(window.sessionStorage, STORAGE_KEY + '_session_id') || newId('ks');
    safeSet(window.sessionStorage, STORAGE_KEY + '_started_at', String(sessionStartedAt));
    safeSet(window.sessionStorage, STORAGE_KEY + '_session_id', sessionId);

    state.version = VERSION;
    state.attribution_id = state.attribution_id || newId('ka');
    state.session_id = sessionId;
    state.session_started_at = new Date(sessionStartedAt).toISOString();
    state.updated_at = new Date(timestamp).toISOString();
    return state;
  }

  function capture() {
    var state = loadState();
    var touch = readTouch();

    if (!state.first_touch) {
      state.first_touch = touch;
    }
    if (!state.last_touch || touch.has_campaign_signal) {
      state.last_touch = touch;
    }

    state.identifiers = state.identifiers || {};
    TOUCH_KEYS.slice(6).forEach(function (key) {
      if (touch[key]) state.identifiers[key] = touch[key];
    });
    state.identifiers.ga_client_id = gaClientId() || state.identifiers.ga_client_id || '';
    state.identifiers.ga_session_id = gaSessionId() || state.identifiers.ga_session_id || '';
    state.identifiers.fbp = cookie('_fbp') || state.identifiers.fbp || '';
    state.identifiers.fbc = cookie('_fbc') || state.identifiers.fbc || '';
    if (!state.identifiers.fbc && state.identifiers.fbclid) {
      state.identifiers.fbc = 'fb.1.' + now() + '.' + state.identifiers.fbclid;
    }

    safeSet(window.localStorage, STORAGE_KEY, JSON.stringify(state));

    var legacyTouch = state.last_touch || state.first_touch || {};
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (key) {
      safeSet(window.localStorage, key, legacyTouch[key] || '');
    });
    return state;
  }

  function hydrateGoogleIdentifiers() {
    var state = capture();
    var ids = state.identifiers || {};
    if (typeof window.gtag !== 'function') return Promise.resolve(state);

    return new Promise(function (resolve) {
      var finished = false;
      var pending = 2;
      var timeout = window.setTimeout(function () {
        pending = 1;
        done();
      }, 350);

      function done() {
        if (finished) return;
        pending -= 1;
        if (pending > 0) return;
        finished = true;
        window.clearTimeout(timeout);
        state.identifiers = ids;
        state.updated_at = new Date().toISOString();
        safeSet(window.localStorage, STORAGE_KEY, JSON.stringify(state));
        resolve(state);
      }

      try {
        window.gtag('get', GA_MEASUREMENT_ID, 'client_id', function (value) {
          ids.ga_client_id = clean(value, 100) || ids.ga_client_id || '';
          done();
        });
        window.gtag('get', GA_MEASUREMENT_ID, 'session_id', function (value) {
          ids.ga_session_id = clean(value, 100) || ids.ga_session_id || '';
          done();
        });
      } catch (error) {
        pending = 1;
        done();
      }
    });
  }

  function cartAttributes(state) {
    var first = state.first_touch || {};
    var last = state.last_touch || first;
    var ids = state.identifiers || {};
    return {
      kuuraii_attr_version: VERSION,
      kuuraii_attribution_id: clean(state.attribution_id, 100),
      kuuraii_session_id: clean(state.session_id, 100),
      kuuraii_first_source: clean(first.utm_source, 100),
      kuuraii_first_medium: clean(first.utm_medium, 100),
      kuuraii_first_campaign: clean(first.utm_campaign, 200),
      kuuraii_first_campaign_id: clean(first.utm_id, 200),
      kuuraii_last_source: clean(last.utm_source, 100),
      kuuraii_last_medium: clean(last.utm_medium, 100),
      kuuraii_last_campaign: clean(last.utm_campaign, 200),
      kuuraii_last_campaign_id: clean(last.utm_id, 200),
      kuuraii_last_content: clean(last.utm_content, 200),
      kuuraii_last_term: clean(last.utm_term, 200),
      kuuraii_fbclid: clean(ids.fbclid, 255),
      kuuraii_fbp: clean(ids.fbp, 255),
      kuuraii_fbc: clean(ids.fbc, 255),
      kuuraii_gclid: clean(ids.gclid, 255),
      kuuraii_gbraid: clean(ids.gbraid, 255),
      kuuraii_wbraid: clean(ids.wbraid, 255),
      kuuraii_ttclid: clean(ids.ttclid, 255),
      kuuraii_ga_client_id: clean(ids.ga_client_id, 100),
      kuuraii_ga_session_id: clean(ids.ga_session_id, 100),
      kuuraii_meta_campaign_id: clean(ids.campaign_id || last.utm_id, 200),
      kuuraii_meta_adset_id: clean(ids.adset_id, 200),
      kuuraii_meta_ad_id: clean(ids.ad_id, 200),
      kuuraii_meta_placement: clean(ids.placement, 100),
      kuuraii_meta_source: clean(ids.site_source_name, 100),
      kuuraii_landing_page: clean(first.landing_page, 500),
      kuuraii_referrer: clean(first.referrer, 500)
    };
  }

  function fillAttributeInputs(attributes) {
    Object.keys(attributes).forEach(function (key) {
      var selector = '[name="attributes[' + key.replace(/"/g, '\\"') + ']"]';
      document.querySelectorAll(selector).forEach(function (input) {
        input.value = attributes[key];
      });
    });

    var last = capture().last_touch || {};
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (key) {
      document.querySelectorAll('[name="attributes[' + key + ']"]').forEach(function (input) {
        input.value = last[key] || '';
      });
    });
  }

  function getCart() {
    return fetchWithTimeout('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to read cart');
      return response.json();
    });
  }

  function syncCart(force) {
    return hydrateGoogleIdentifiers().then(function (state) {
      var attributes = cartAttributes(state);
      var serialized = JSON.stringify(attributes);
      var syncHash = hash(serialized);
      fillAttributeInputs(attributes);

      if (!force && safeGet(window.sessionStorage, SYNC_KEY) === syncHash) {
        return attributes;
      }

      return fetchWithTimeout('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ attributes: attributes })
      }).then(function (response) {
        if (!response.ok) throw new Error('Unable to persist attribution to cart');
        safeSet(window.sessionStorage, SYNC_KEY, syncHash);
        return attributes;
      });
    });
  }

  function lineItem(item, index) {
    return {
      item_id: clean(item.sku || item.product_id || item.variant_id, 100),
      item_name: clean(item.product_title || item.title, 200),
      item_brand: clean(item.vendor, 100),
      item_variant: clean(item.variant_title, 100),
      price: Number(item.final_price || item.price || 0) / 100,
      quantity: Number(item.quantity || 1),
      index: index
    };
  }

  function emitCheckoutHandoff(cart) {
    if (!cart || !cart.item_count) return;
    var state = capture();
    var bucket = Math.floor(now() / (30 * 60 * 1000));
    var eventId = 'bc_' + hash(clean(cart.token, 200) + '|' + state.session_id + '|' + bucket);
    var existing = parseJson(safeGet(window.sessionStorage, HANDOFF_KEY), {});
    if (existing.event_id === eventId) return;

    var payload = {
      event: 'kuuraii_checkout_handoff',
      kuuraii_event_id: eventId,
      kuuraii_attribution_id: state.attribution_id,
      ecommerce: {
        currency: clean(cart.currency || 'INR', 10),
        value: Number(cart.total_price || 0) / 100,
        items: (cart.items || []).map(lineItem)
      }
    };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push(payload);
    window.dispatchEvent(new CustomEvent('kuuraii:checkout_handoff', { detail: payload }));
    safeSet(window.sessionStorage, HANDOFF_KEY, JSON.stringify({ event_id: eventId, emitted_at: now() }));
  }

  function prepareCheckout() {
    markStatus('persisting');
    return syncCart(true).then(getCart).then(function (cart) {
      emitCheckoutHandoff(cart);
      markStatus('ready');
      return cart;
    });
  }

  function prepareCheckoutWithDeadline() {
    return new Promise(function (resolve, reject) {
      var settled = false;
      var timeout = window.setTimeout(function () {
        if (settled) return;
        settled = true;
        reject(new Error('Checkout preparation timed out'));
      }, CHECKOUT_PREPARE_TIMEOUT_MS);

      Promise.resolve().then(prepareCheckout).then(function (cart) {
        if (settled) return;
        settled = true;
        window.clearTimeout(timeout);
        resolve(cart);
      }).catch(function (error) {
        if (settled) return;
        settled = true;
        window.clearTimeout(timeout);
        reject(error);
      });
    });
  }

  function fallbackCheckout() {
    window.location.assign('/checkout');
  }

  function startQuickCheckout(trigger) {
    if (checkoutInProgress) return Promise.resolve();
    checkoutInProgress = true;
    if (trigger) trigger.setAttribute('aria-busy', 'true');

    return prepareCheckoutWithDeadline().catch(function (error) {
      console.warn('[Kuuraii attribution] Checkout metadata could not be fully persisted.', error);
    }).then(function () {
      if (trigger) trigger.removeAttribute('aria-busy');
      checkoutInProgress = false;
      fallbackCheckout();
    });
  }

  function replayNativeCheckout(element) {
    return prepareCheckoutWithDeadline().catch(function (error) {
      markStatus('continuing-without-cart-context');
      console.warn('[Kuuraii attribution] Checkout metadata could not be fully persisted.', error);
    }).then(function () {
      checkoutInProgress = false;
      markStatus('replaying-native-checkout');
      replayingElement = element;
      element.click();
      replayingElement = null;
    });
  }

  function checkoutClick(event) {
    var element = event.target && event.target.closest ? event.target.closest(CHECKOUT_SELECTOR) : null;
    if (!element || element.disabled) return;

    /*
      Shopify owns the checkout handoff. This listener records attribution
      without delaying, replaying, or taking over the customer's checkout.
    */
    prepareCheckoutWithDeadline().catch(function (error) {
      markStatus('continuing-without-cart-context');
      console.warn('[Kuuraii attribution] Checkout metadata could not be fully persisted.', error);
    });
  }

  function refresh() {
    var state = capture();
    fillAttributeInputs(cartAttributes(state));
  }

  window.KuuraiiAttribution = {
    getState: function () { return capture(); },
    getCartAttributes: function () { return cartAttributes(capture()); },
    flush: function () { return syncCart(true); },
    startQuickCheckout: startQuickCheckout,
    refresh: refresh
  };

  document.documentElement.setAttribute('data-kuuraii-session-context', VERSION);

  markStatus('initializing');
  try {
    capture();
  } catch (error) {
    markStatus('capture-error');
    console.warn('[Kuuraii attribution] Initial campaign context could not be captured.', error);
  }
  document.addEventListener('click', checkoutClick, true);
  markStatus('listener-ready');
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh, { once: true });
  } else {
    refresh();
  }
  window.addEventListener('pageshow', refresh);
  window.setTimeout(refresh, 1000);
  window.setTimeout(refresh, 3000);
})();
